<template>
  <div class="left-menu">
    <el-menu
      ref="menu"
      :default-active="activeMenu"
      class="el-menu-vertical-demo"
      unique-opened
      :collapse="!showLogo"
      router
      @open="openMenu"
      @select="selectMenu"
    >
      <template v-for="item in menuList">
        <!-- 不包含子菜单的“一级菜单” -->
        <el-menu-item :index="getPath(item)" :key="`menu-${item.path}`" v-if="!item.children">
          <i :class="item.meta.icon"></i>
          <span slot="title">{{ item.meta && item.meta.name }}</span>
        </el-menu-item>

        <!-- 包含子菜单的“一级菜单” -->
        <el-submenu :index="getPath(item)" :key="`submenu-${item.path}`" v-else>
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{ item.meta && item.meta.name }}</span>
          </template>
          <!-- 循环渲染“二级菜单” -->
          <template v-for="subItem in item.children">
            <el-menu-item :index="getPath(subItem)" :key="subItem.path" v-if="!subItem.meta.hidden">
              <i :class="subItem.meta.icon"></i>
              {{ subItem.meta && subItem.meta.name }}
            </el-menu-item>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LeftMenu',

  data() {
    return {
      isCollapse: false,
      showLogo: true,
      defaultSelectMenu: this.$route.path,
      currentOpenKey: ''
    }
  },

  computed: {
    ...mapGetters(['getResultRoutes']),

    menuList() {
      const routes = this.getResultRoutes
      return routes.filter(item => {
        return !item.meta.hidden
      })
    },

    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },

  mounted() {
    this.defaultSelectMenu = sessionStorage.getItem('keyPath') || '/home'
    this.$bus.$on('showLogo', () => {
      this.showLogo = !this.showLogo
    })
  },

  watch: {
    defaultSelectMenu: {
      immediate: true,
      handler(newV, oldV) {}
    },

    $route: {
      handler(newV, oldV) {
        this.defaultSelectMenu = this.$route.path
      }
    }
  },

  methods: {
    openMenu(index, indexPath) {
      sessionStorage.setItem('keyPath', this.defaultSelectMenu)
    },

    selectMenu(index, indexPath) {
      sessionStorage.setItem('keyPath', index)
      if (index == '/home') {
        this.$refs.menu.close(`/${this.$route.path.split('/')[1]}`)
        this.defaultSelectMenu = index
      }
    },

    getPath (route) {
      const meta = route.meta
      return meta.realPath || route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.left-menu {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
  padding: 12px 0;
  
  ::v-deep {
    .el-menu {
      border-right: none;
      background: transparent;
      padding: 0 8px;
      
      .el-menu-item,
      .el-submenu__title {
        height: 48px;
        line-height: 48px;
        margin-bottom: 4px;
        border-radius: 8px;
        padding: 0 16px !important;
        color: #606266;
        font-size: 14px;
        transition: all 0.3s ease;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        
        i {
          font-size: 18px;
          margin-right: 12px;
          color: #909399;
          transition: all 0.3s ease;
          width: 18px;
          text-align: center;
          display: inline-block;
        }
        
        span {
          font-weight: 500;
          transition: all 0.3s ease;
        }
        
        &:hover {
          background: linear-gradient(135deg, rgba($brand-primary, 0.1) 0%, rgba($brand-primary-light, 0.05) 100%) !important;
          color: $brand-primary !important;
          
          i {
            color: $brand-primary;
            transform: scale(1.1);
          }
        }
      }
      
      .el-menu-item {
        &.is-active {
          background: linear-gradient(135deg, $brand-primary 0%, $brand-primary-light 100%) !important;
          color: #ffffff !important;
          box-shadow: 0 2px 8px rgba($brand-primary, 0.3);
          
          i {
            color: #ffffff;
            transform: scale(1.1);
          }
          
          span {
            font-weight: 600;
          }
        }
      }
      
      .el-submenu {
        .el-submenu__title {
          position: relative;
          
          .el-submenu__icon-arrow {
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            margin-top: 0;
            margin-right: 0;
            color: #909399;
            font-size: 12px;
            transition: all 0.3s ease;
          }
          
          &:hover {
            .el-submenu__icon-arrow {
              color: $brand-primary;
            }
          }
        }
        
        &.is-opened {
          > .el-submenu__title {
            color: $brand-primary;
            background: linear-gradient(135deg, rgba($brand-primary, 0.08) 0%, rgba($brand-primary-light, 0.04) 100%) !important;
            
            i {
              color: $brand-primary;
            }
            
            .el-submenu__icon-arrow {
              color: $brand-primary;
              transform: translateY(-50%) rotate(180deg);
            }
          }
        }
        
        .el-menu {
          background: rgba(248, 250, 255, 0.5);
          padding: 6px 0;
          margin-top: 4px;
          margin-left: -8px;
          border-radius: 8px;
          
          .el-menu-item {
            padding: 0 16px 0 24px !important;
            height: 40px;
            line-height: 40px;
            margin: 2px 8px;
            // 覆盖 element 默认的 min-width: 200px，避免子菜单项撑宽后被
            // .left-menu 的 overflow-x: hidden 裁掉右侧圆角
            min-width: auto;
            border-radius: 8px;
            font-size: 13px;
            white-space: nowrap;
            
            i {
              font-size: 16px;
              margin-right: 10px;
            }
            
            &:hover {
              background: linear-gradient(135deg, rgba($brand-primary, 0.12) 0%, rgba($brand-primary-light, 0.06) 100%) !important;
              color: $brand-primary !important;
              
              i {
                color: $brand-primary;
              }
            }
            
            &.is-active {
              background: linear-gradient(135deg, $brand-primary 0%, $brand-primary-light 100%) !important;
              color: #ffffff !important;
              box-shadow: 0 2px 6px rgba($brand-primary, 0.25);
              
              i {
                color: #ffffff;
              }
            }
          }
        }
      }
    }
    
    .el-menu--collapse {
      width: 100%;
      padding: 0 4px;
      
      .el-menu-item,
      .el-submenu__title {
        padding: 0 16px !important;
        justify-content: center;
        
        i {
          margin-right: 0;
        }
        
        span {
          display: none;
        }
      }
      
      .el-submenu__title {
        .el-submenu__icon-arrow {
          display: none;
        }
      }
    }
  }
}

// 美化滚动条
.left-menu::-webkit-scrollbar {
  width: 6px;
}

.left-menu::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 10px;
}

.left-menu::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba($brand-primary, 0.3) 0%, rgba($brand-primary-light, 0.2) 100%);
  border-radius: 10px;
  transition: background 0.3s ease;
  
  &:hover {
    background: linear-gradient(180deg, rgba($brand-primary, 0.5) 0%, rgba($brand-primary-light, 0.4) 100%);
  }
}
</style>
